import { UnhandledError } from '../errors';

type AnyFunction = (...args: any[]) => any;
type AnyAsyncFunction = (...args: any[]) => Promise<any>;
type SafeCallback<Fn extends AnyFunction | AnyAsyncFunction> =
  Fn extends AnyAsyncFunction
    ? (...args: Parameters<Fn>) => Promise<void>
    : (...args: Parameters<Fn>) => void;

const rethrow = (err: any, isAsync = false) => {
  setTimeout(() => {
    throw new UnhandledError(
      isAsync ? UnhandledError.Reason.ASYNC_ERROR : UnhandledError.Reason.ERROR,
      {
        messageArgs: [err as Error],
        originalError: err as Error,
      }
    );
  }, 0);
};

export function safeCallback<Fn extends AnyFunction | AnyAsyncFunction>(
  fn: Fn
): SafeCallback<Fn> {
  const wrapped = (...args: Parameters<Fn>) => {
    try {
      const result = fn(...args);
      if (result instanceof Promise) {
        return result
          .then(() => undefined)
          .catch((err) => {
            rethrow(err, true);
          });
      }
    } catch (err) {
      rethrow(err, false);
    }
  };
  return wrapped as SafeCallback<Fn>;
}
